import { INSURANCE_TYPE_INSURANCE, INSURANCE_TYPE_CASH, INSURANCE_TYPE_CASH_AND_INSURANCE } from 'constants/common';

export enum EPPAStep {
    // create profile
    STEP_1 = 'STEP_1',
    STEP_2 = 'STEP_2',
    STEP_3 = 'STEP_3',
    STEP_4 = 'STEP_4',
    // service setup
    STEP_5 = 'STEP_5',
    STEP_6 = 'STEP_6',
    STEP_7 = 'STEP_7',
    STEP_8 = 'STEP_8',

    // list on klarity
    STEP_9 = 'STEP_9',
    STEP_10 = 'STEP_10',
    STEP_11 = 'STEP_11',
    STEP_12 = 'STEP_12',
    STEP_13 = 'STEP_13',

    // configure availability
    STEP_14 = 'STEP_14',
    STEP_15 = 'STEP_15',
    STEP_16 = 'STEP_16',
    STEP_17 = 'STEP_17',
    STEP_17_1 = 'STEP_17_1',
    // review
    STEP_18 = 'STEP_18',
    // finish page
    STEP_19 = 'STEP_19',
    // advance setting start
    STEP_20 = 'STEP_20',
    // finish advance setting / skip advance setting
    STEP_21 = 'STEP_21',

}

export interface IPPAOnboardingStepResponse {
    createAt: string;
    createBy: number;
    currentStep: EPPAStep;
    endFlag: boolean;
    id: number;
    providerId: number;
    stepType: 'KLARITY_ONBOARDING';
    updateAt: string;
    updateBy: number;
}

export interface ISaveBasicInfo {
    firstName?: string,
    lastName?: string,
    credential?: string[] | string;
    gender?: string;
}

export interface IPPAServiceSpecialty {
    id: number;
    specialtyName: string;
    description: string;
    commonCondition: string;
    createAt: string;
    createBy: number;
    iconUri: string;
    iconUrl?: string;
    image: string;
    patientDescription: string;
    providerConditions?: string;
    serversTypeNames?: string[];
    serversTypes: string[];
    updateAt: string;
    updateBy: number;
}

export interface IPPAServiceDetailResponse {
    selectedSpecialty?: string;
    selectedState?: string[];
    supportPayType?: typeof INSURANCE_TYPE_INSURANCE | typeof INSURANCE_TYPE_CASH | typeof INSURANCE_TYPE_CASH_AND_INSURANCE;
}

export interface IPPAServicePriceConfigResponse {
    createdAt: string;
    duration: number;
    id: number;
    price: number;
    serviceType: string;
    specialty: string;
    state: string;
    updatedAt: string;
}

export interface IPPAPersonalIdentification {
    identification: {
        type: string;
        frontUrl: string;
        backUrl?: string;
    }
}

export interface PPAServicePriceConfig {
    duration: number;
    price: number;
    serviceType: string;
    specialty: string;
    state: string;
}
